import { render, staticRenderFns } from "./SingleGrant.vue?vue&type=template&id=d07de33a&scoped=true&"
import script from "./SingleGrant.vue?vue&type=script&lang=js&"
export * from "./SingleGrant.vue?vue&type=script&lang=js&"
import style0 from "./SingleGrant.vue?vue&type=style&index=0&id=d07de33a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07de33a",
  null
  
)

export default component.exports